export default __webpack_public_path__ + "static/media/api-powered-ecosystem-2x.3c364e4b.jpg";